"use client";

import { useSyncExternalStore } from "react";
import { localTodayYmd, utcTodayYmd } from "@/lib/game-date";

const subscribe = () => () => {};
const getLocalToday = () => localTodayYmd();
const getUtcToday = () => utcTodayYmd();

export function useTodayYmd(): string {
  return useSyncExternalStore(subscribe, getLocalToday, getUtcToday);
}
